import React from "react";

export function LoadingSVG() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.25V4.75M12 18V22M5.75 12H2.25M21.25 12H19.75M18.4571 18.4571L17.75 17.75M18.6642 5.41579L17.25 6.83M4.92157 19.0784L7.75 16.25M5.12868 5.20868L7.25 7.33"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const CommentSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShareSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SendBtnSVG = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.54329 8.4981L2.22448 9.109L0.561704 14.4269C0.46256 14.7413 0.559815 15.085 0.810023 15.3003C1.05929 15.5155 1.41338 15.5609 1.70988 15.4164L15.5578 8.71059C15.8289 8.5784 16.0007 8.30363 16.0007 8.00242C16.0007 7.70121 15.8288 7.42645 15.5578 7.29425L1.7193 0.583602C1.42281 0.439136 1.06874 0.484459 0.81945 0.699742C0.569221 0.915027 0.471977 1.25778 0.571131 1.57221L2.2339 6.89006L8.5404 7.50191C8.79533 7.5274 8.98985 7.74174 8.98985 7.99762C8.98985 8.25352 8.79534 8.46784 8.5404 8.49334L8.54329 8.4981Z"
        fill="#0B1F14"
      />
    </svg>
  );
};

export const BackBtnSVG = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7H1M1 7L7 13M1 7L7 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GoogleDriveSVG = () => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 -13.5 256 256"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <g>
        <path
          d="M19.3542312,196.033928 L30.644172,215.534816 C32.9900287,219.64014 36.3622164,222.86588 40.3210929,225.211737 C51.6602421,210.818376 59.5534225,199.772864 64.000634,192.075201 C68.5137119,184.263529 74.0609657,172.045039 80.6423954,155.41973 C62.9064315,153.085282 49.4659974,151.918058 40.3210929,151.918058 C31.545465,151.918058 18.1051007,153.085282 0,155.41973 C0,159.964996 1.17298825,164.510261 3.51893479,168.615586 L19.3542312,196.033928 Z"
          fill="#0066DA"
        ></path>
        <path
          d="M215.681443,225.211737 C219.64032,222.86588 223.012507,219.64014 225.358364,215.534816 L230.050377,207.470615 L252.483511,168.615586 C254.829368,164.510261 256.002446,159.964996 256.002446,155.41973 C237.79254,153.085282 224.376613,151.918058 215.754667,151.918058 C206.488712,151.918058 193.072785,153.085282 175.506888,155.41973 C182.010479,172.136093 187.484394,184.354584 191.928633,192.075201 C196.412073,199.863919 204.329677,210.909431 215.681443,225.211737 Z"
          fill="#EA4335"
        ></path>
        <path
          d="M128.001268,73.3111515 C141.121182,57.4655263 150.162898,45.2470011 155.126415,36.6555757 C159.123121,29.7376196 163.521739,18.6920726 168.322271,3.51893479 C164.363395,1.1729583 159.818129,0 155.126415,0 L100.876121,0 C96.1841079,0 91.638842,1.31958557 87.6799655,3.51893479 C93.7861943,20.9210065 98.9675428,33.3058067 103.224011,40.6733354 C107.927832,48.8151881 116.186918,59.6944602 128.001268,73.3111515 Z"
          fill="#00832D"
        ></path>
        <path
          d="M175.360141,155.41973 L80.6420959,155.41973 L40.3210929,225.211737 C44.2799694,227.557893 48.8252352,228.730672 53.5172481,228.730672 L202.485288,228.730672 C207.177301,228.730672 211.722567,227.411146 215.681443,225.211737 L175.360141,155.41973 Z"
          fill="#2684FC"
        ></path>
        <path
          d="M128.001268,73.3111515 L87.680265,3.51893479 C83.7213885,5.86488134 80.3489013,9.09044179 78.0030446,13.1960654 L3.51893479,142.223575 C1.17298825,146.329198 0,150.874464 0,155.41973 L80.6423954,155.41973 L128.001268,73.3111515 Z"
          fill="#00AC47"
        ></path>
        <path
          d="M215.241501,77.7099697 L177.999492,13.1960654 C175.653635,9.09044179 172.281148,5.86488134 168.322271,3.51893479 L128.001268,73.3111515 L175.360141,155.41973 L255.855999,155.41973 C255.855999,150.874464 254.682921,146.329198 252.337064,142.223575 L215.241501,77.7099697 Z"
          fill="#FFBA00"
        ></path>
      </g>
    </svg>
  );
};

export const OneDriveSVG = () => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_87_7796"
        maskUnits="userSpaceOnUse"
        x="0"
        y="6"
        width="32"
        height="20"
      >
        <path
          d="M7.82979 26C3.50549 26 0 22.5675 0 18.3333C0 14.1921 3.35322 10.8179 7.54613 10.6716C9.27535 7.87166 12.4144 6 16 6C20.6308 6 24.5169 9.12183 25.5829 13.3335C29.1316 13.3603 32 16.1855 32 19.6667C32 23.0527 29 26 25.8723 25.9914L7.82979 26Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_87_7796)">
        <path
          d="M7.83017 26.0001C5.37824 26.0001 3.18957 24.8966 1.75391 23.1691L18.0429 16.3335L30.7089 23.4647C29.5926 24.9211 27.9066 26.0001 26.0004 25.9915C23.1254 26.0001 12.0629 26.0001 7.83017 26.0001Z"
          fill="url(#paint0_linear_87_7796)"
        />
        <path
          d="M25.5785 13.3149L18.043 16.3334L30.709 23.4647C31.5199 22.4065 32.0004 21.0916 32.0004 19.6669C32.0004 16.1857 29.1321 13.3605 25.5833 13.3337C25.5817 13.3274 25.5801 13.3212 25.5785 13.3149Z"
          fill="url(#paint1_linear_87_7796)"
        />
        <path
          d="M7.06445 10.7028L18.0423 16.3333L25.5779 13.3148C24.5051 9.11261 20.6237 6 15.9997 6C12.4141 6 9.27508 7.87166 7.54586 10.6716C7.3841 10.6773 7.22358 10.6877 7.06445 10.7028Z"
          fill="url(#paint2_linear_87_7796)"
        />
        <path
          d="M1.7535 23.1687L18.0425 16.3331L7.06471 10.7026C3.09947 11.0792 0 14.3517 0 18.3331C0 20.1665 0.657197 21.8495 1.7535 23.1687Z"
          fill="url(#paint3_linear_87_7796)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_87_7796"
          x1="4.42591"
          y1="24.6668"
          x2="27.2309"
          y2="23.2764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2086B8" />
          <stop offset="1" stop-color="#46D3F6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_87_7796"
          x1="23.8302"
          y1="19.6668"
          x2="30.2108"
          y2="15.2082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1694DB" />
          <stop offset="1" stop-color="#62C3FE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_87_7796"
          x1="8.51037"
          y1="7.33333"
          x2="23.3335"
          y2="15.9348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0D3D78" />
          <stop offset="1" stop-color="#063B83" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_87_7796"
          x1="-0.340429"
          y1="19.9998"
          x2="14.5634"
          y2="14.4649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#16589B" />
          <stop offset="1" stop-color="#1464B7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PlusSignSVG = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19M5 12H19"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GooglePhotosSVG = () => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 256 256"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <g>
        <path
          d="M64,58.1485714 C99.328,58.1485714 128,86.8205714 128,122.148571 L128,122.148571 L128,128 L5.85142857,128 C2.63314286,128 0,125.366857 0,122.148571 C0,86.8205714 28.672,58.1485714 64,58.1485714 L64,58.1485714 Z"
          fill="#FBBB05"
        ></path>
        <path
          d="M197.851429,64 C197.851429,99.328 169.179429,128 133.851429,128 L128,128 L128,5.85142857 C128,2.63314286 130.633143,0 133.851429,0 L133.851429,0 C169.179429,0 197.851429,28.672 197.851429,64 Z"
          fill="#E94335"
        ></path>
        <path
          d="M192,197.851429 C156.672,197.851429 128,169.179429 128,133.851429 L128,133.851429 L128,128 L250.148571,128 C253.366857,128 256,130.633143 256,133.851429 L256,133.851429 C256,169.179429 227.328,197.851429 192,197.851429 L192,197.851429 Z"
          fill="#4285F4"
        ></path>
        <path
          d="M58.1485714,192 C58.1485714,156.672 86.8205714,128 122.148571,128 L128,128 L128,250.148571 C128,253.366857 125.366857,256 122.148571,256 L122.148571,256 C86.8205714,256 58.1485714,227.328 58.1485714,192 Z"
          fill="#0F9D58"
        ></path>
      </g>
    </svg>
  );
};

export const StoryImgSVG = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V15.2C1 16.8802 1 17.7202 1.32698 18.362C1.6146 18.9265 2.07354 19.3854 2.63803 19.673C3.27976 20 4.11984 20 5.8 20H15C15.93 20 16.395 20 16.7765 19.8978C17.8117 19.6204 18.6204 18.8117 18.8978 17.7765C19 17.395 19 16.93 19 16M17 7V1M14 4H20M8.5 7.5C8.5 8.60457 7.60457 9.5 6.5 9.5C5.39543 9.5 4.5 8.60457 4.5 7.5C4.5 6.39543 5.39543 5.5 6.5 5.5C7.60457 5.5 8.5 6.39543 8.5 7.5ZM12.99 10.9181L4.53115 18.608C4.05536 19.0406 3.81747 19.2568 3.79643 19.4442C3.77819 19.6066 3.84045 19.7676 3.96319 19.8755C4.10478 20 4.42628 20 5.06929 20H14.456C15.8951 20 16.6147 20 17.1799 19.7582C17.8894 19.4547 18.4547 18.8894 18.7582 18.1799C19 17.6147 19 16.8951 19 15.456C19 14.9717 19 14.7296 18.9471 14.5042C18.8805 14.2208 18.753 13.9554 18.5733 13.7264C18.4303 13.5442 18.2412 13.3929 17.8631 13.0905L15.0658 10.8527C14.6874 10.5499 14.4982 10.3985 14.2898 10.3451C14.1061 10.298 13.9129 10.3041 13.7325 10.3627C13.5279 10.4291 13.3486 10.5921 12.99 10.9181Z"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StoryVidSVG = () => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.5V13.6C21 15.8402 21 16.9603 20.564 17.816C20.1805 18.5686 19.5686 19.1805 18.816 19.564C17.9603 20 16.8402 20 14.6 20H7.4C5.15979 20 4.03969 20 3.18404 19.564C2.43139 19.1805 1.81947 18.5686 1.43597 17.816C1 16.9603 1 15.8402 1 13.6V8.4C1 6.15979 1 5.03969 1.43597 4.18404C1.81947 3.43139 2.43139 2.81947 3.18404 2.43597C4.03969 2 5.15979 2 7.4 2H11.5M18 7V1M15 4H21M15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11Z"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProdImgSVG = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V15.2C1 16.8802 1 17.7202 1.32698 18.362C1.6146 18.9265 2.07354 19.3854 2.63803 19.673C3.27976 20 4.11984 20 5.8 20H15C15.93 20 16.395 20 16.7765 19.8978C17.8117 19.6204 18.6204 18.8117 18.8978 17.7765C19 17.395 19 16.93 19 16M17 7V1M14 4H20M8.5 7.5C8.5 8.60457 7.60457 9.5 6.5 9.5C5.39543 9.5 4.5 8.60457 4.5 7.5C4.5 6.39543 5.39543 5.5 6.5 5.5C7.60457 5.5 8.5 6.39543 8.5 7.5ZM12.99 10.9181L4.53115 18.608C4.05536 19.0406 3.81747 19.2568 3.79643 19.4442C3.77819 19.6066 3.84045 19.7676 3.96319 19.8755C4.10478 20 4.42628 20 5.06929 20H14.456C15.8951 20 16.6147 20 17.1799 19.7582C17.8894 19.4547 18.4547 18.8894 18.7582 18.1799C19 17.6147 19 16.8951 19 15.456C19 14.9717 19 14.7296 18.9471 14.5042C18.8805 14.2208 18.753 13.9554 18.5733 13.7264C18.4303 13.5442 18.2412 13.3929 17.8631 13.0905L15.0658 10.8527C14.6874 10.5499 14.4982 10.3985 14.2898 10.3451C14.1061 10.298 13.9129 10.3041 13.7325 10.3627C13.5279 10.4291 13.3486 10.5921 12.99 10.9181Z"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProdVidSVG = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.5V13.6C21 15.8402 21 16.9603 20.564 17.816C20.1805 18.5686 19.5686 19.1805 18.816 19.564C17.9603 20 16.8402 20 14.6 20H7.4C5.15979 20 4.03969 20 3.18404 19.564C2.43139 19.1805 1.81947 18.5686 1.43597 17.816C1 16.9603 1 15.8402 1 13.6V8.4C1 6.15979 1 5.03969 1.43597 4.18404C1.81947 3.43139 2.43139 2.81947 3.18404 2.43597C4.03969 2 5.15979 2 7.4 2H11.5M18 7V1M15 4H21M15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11Z"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StoryAddSVG = () => {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1194 20H2.88062C2.39514 20 2 19.6559 2 19.2328V1.76724C2 1.34502 2.39514 1 2.88062 1H14.1194C14.6049 1 15 1.34411 15 1.76724V19.2328C15 19.6559 14.6049 20 14.1194 20ZM2.88062 1.40684C2.65239 1.40684 2.46698 1.56849 2.46698 1.76724V19.2328C2.46698 19.4315 2.65239 19.5947 2.88062 19.5947H14.1194C14.3476 19.5947 14.533 19.433 14.533 19.2328V1.76724C14.533 1.56849 14.3476 1.40684 14.1194 1.40684H2.88062Z"
        fill="#808080"
        stroke="#808080"
      />
      <path
        d="M5 10.5C5 10.2244 5.12731 10 5.28395 10H11.7161C11.8727 10 12 10.2244 12 10.5C12 10.7756 11.8727 11 11.7161 11H5.28395C5.12731 11 5 10.7756 5 10.5Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
      <path
        d="M8.5 7C8.77562 7 9 7.12731 9 7.28395L9 13.7161C9 13.8727 8.77562 14 8.5 14C8.22438 14 8 13.8727 8 13.7161L8 7.28395C8 7.12731 8.22438 7 8.5 7Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
      <path
        d="M17.5004 18C17.566 18 17.631 17.995 17.6916 17.9852C17.7522 17.9754 17.8073 17.9611 17.8537 17.943C17.9 17.925 17.9368 17.9036 17.9618 17.88C17.9869 17.8564 17.9997 17.8311 17.9996 17.8056V3.20206C18.0023 3.17591 17.9913 3.14981 17.9674 3.12535C17.9435 3.10088 17.9071 3.07854 17.8605 3.05967C17.8138 3.0408 17.7578 3.02579 17.6959 3.01554C17.6339 3.00529 17.5673 3 17.5 3C17.4327 3 17.3661 3.00529 17.3041 3.01554C17.2422 3.02579 17.1862 3.0408 17.1395 3.05967C17.0929 3.07854 17.0565 3.10088 17.0326 3.12535C17.0087 3.14981 16.9977 3.17591 17.0004 3.20206V17.8056C17.0004 17.8572 17.0531 17.9066 17.1468 17.9431C17.2406 17.9795 17.3678 18 17.5004 18Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
      <path
        d="M20.4795 16C20.6067 16 20.7286 15.9809 20.8185 15.9468C20.9085 15.9128 20.959 15.8666 20.959 15.8185L21 5.18205C21 5.13387 20.9495 5.08765 20.8597 5.05352C20.7698 5.0194 20.6478 5.00015 20.5205 5C20.3933 5 20.2714 5.01912 20.1815 5.05316C20.0915 5.08719 20.041 5.13336 20.041 5.18149L20 15.8179C19.9999 15.8418 20.0122 15.8655 20.0363 15.8875C20.0603 15.9096 20.0956 15.9297 20.1401 15.9466C20.1847 15.9635 20.2375 15.9769 20.2958 15.9861C20.354 15.9952 20.4164 16 20.4795 16Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const StoryRemoveSVG = () => {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1194 20H2.88062C2.39514 20 2 19.6559 2 19.2328V1.76724C2 1.34502 2.39514 1 2.88062 1H14.1194C14.6049 1 15 1.34411 15 1.76724V19.2328C15 19.6559 14.6049 20 14.1194 20ZM2.88062 1.40684C2.65239 1.40684 2.46698 1.56849 2.46698 1.76724V19.2328C2.46698 19.4315 2.65239 19.5947 2.88062 19.5947H14.1194C14.3476 19.5947 14.533 19.433 14.533 19.2328V1.76724C14.533 1.56849 14.3476 1.40684 14.1194 1.40684H2.88062Z"
        fill="#808080"
        stroke="#808080"
      />
      <path
        d="M5 10.5C5 10.2244 5.12731 10 5.28395 10H11.7161C11.8727 10 12 10.2244 12 10.5C12 10.7756 11.8727 11 11.7161 11H5.28395C5.12731 11 5 10.7756 5 10.5Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
      <path
        d="M17.5004 18C17.566 18 17.631 17.995 17.6916 17.9852C17.7522 17.9754 17.8073 17.9611 17.8537 17.943C17.9 17.925 17.9368 17.9036 17.9618 17.88C17.9869 17.8564 17.9997 17.8311 17.9996 17.8056V3.20206C18.0023 3.17591 17.9913 3.14981 17.9674 3.12535C17.9435 3.10088 17.9071 3.07854 17.8605 3.05967C17.8138 3.0408 17.7578 3.02579 17.6959 3.01554C17.6339 3.00529 17.5673 3 17.5 3C17.4327 3 17.3661 3.00529 17.3041 3.01554C17.2422 3.02579 17.1862 3.0408 17.1395 3.05967C17.0929 3.07854 17.0565 3.10088 17.0326 3.12535C17.0087 3.14981 16.9977 3.17591 17.0004 3.20206V17.8056C17.0004 17.8572 17.0531 17.9066 17.1468 17.9431C17.2406 17.9795 17.3678 18 17.5004 18Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
      <path
        d="M20.4795 16C20.6067 16 20.7286 15.9809 20.8185 15.9468C20.9085 15.9128 20.959 15.8666 20.959 15.8185L21 5.18205C21 5.13387 20.9495 5.08765 20.8597 5.05352C20.7698 5.0194 20.6478 5.00015 20.5205 5C20.3933 5 20.2714 5.01912 20.1815 5.05316C20.0915 5.08719 20.041 5.13336 20.041 5.18149L20 15.8179C19.9999 15.8418 20.0122 15.8655 20.0363 15.8875C20.0603 15.9096 20.0956 15.9297 20.1401 15.9466C20.1847 15.9635 20.2375 15.9769 20.2958 15.9861C20.354 15.9952 20.4164 16 20.4795 16Z"
        fill="#808080"
        stroke="#808080"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const StoryTextSVG = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.015625 0.984375H13.9844V3.98438H8.5V15.9844H5.5V3.98438H0.015625V0.984375Z"
        fill="#808080"
      />
    </svg>
  );
};

export const LocationSVG = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.9974 8.16536C8.10196 8.16536 8.9974 7.26993 8.9974 6.16536C8.9974 5.0608 8.10196 4.16536 6.9974 4.16536C5.89283 4.16536 4.9974 5.0608 4.9974 6.16536C4.9974 7.26993 5.89283 8.16536 6.9974 8.16536Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.9974 14.1654C9.66406 11.4987 12.3307 9.11088 12.3307 6.16536C12.3307 3.21985 9.94291 0.832031 6.9974 0.832031C4.05188 0.832031 1.66406 3.21985 1.66406 6.16536C1.66406 9.11088 4.33073 11.4987 6.9974 14.1654Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailSVG = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33594 3.16797L6.77922 6.97826C7.22 7.28681 7.44039 7.44108 7.68011 7.50084C7.89187 7.55362 8.11334 7.55362 8.3251 7.50084C8.56482 7.44108 8.78521 7.28681 9.22599 6.97826L14.6693 3.16797M4.53594 11.8346H11.4693C12.5894 11.8346 13.1494 11.8346 13.5773 11.6166C13.9536 11.4249 14.2595 11.1189 14.4513 10.7426C14.6693 10.3148 14.6693 9.75474 14.6693 8.63463V4.36797C14.6693 3.24786 14.6693 2.68781 14.4513 2.25999C14.2595 1.88366 13.9536 1.5777 13.5773 1.38596C13.1494 1.16797 12.5894 1.16797 11.4693 1.16797H4.53594C3.41583 1.16797 2.85578 1.16797 2.42796 1.38596C2.05163 1.5777 1.74567 1.88366 1.55392 2.25999C1.33594 2.68781 1.33594 3.24786 1.33594 4.36797V8.63463C1.33594 9.75474 1.33594 10.3148 1.55392 10.7426C1.74567 11.1189 2.05163 11.4249 2.42796 11.6166C2.85578 11.8346 3.41583 11.8346 4.53594 11.8346Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRightSVG = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StoryIconSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18V6C10 5.06812 10 4.60218 9.84776 4.23463C9.64477 3.74458 9.25542 3.35523 8.76537 3.15224C8.39782 3 7.93188 3 7 3C6.06812 3 5.60218 3 5.23463 3.15224C4.74458 3.35523 4.35523 3.74458 4.15224 4.23463C4 4.60218 4 5.06812 4 6V18C4 18.9319 4 19.3978 4.15224 19.7654C4.35523 20.2554 4.74458 20.6448 5.23463 20.8478C5.60218 21 6.06812 21 7 21C7.93188 21 8.39782 21 8.76537 20.8478C9.25542 20.6448 9.64477 20.2554 9.84776 19.7654C10 19.3978 10 18.9319 10 18Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 16V8C20 7.06812 20 6.60218 19.8478 6.23463C19.6448 5.74458 19.2554 5.35523 18.7654 5.15224C18.3978 5 17.9319 5 17 5C16.0681 5 15.6022 5 15.2346 5.15224C14.7446 5.35523 14.3552 5.74458 14.1522 6.23463C14 6.60218 14 7.06812 14 8V16C14 16.9319 14 17.3978 14.1522 17.7654C14.3552 18.2554 14.7446 18.6448 15.2346 18.8478C15.6022 19 16.0681 19 17 19C17.9319 19 18.3978 19 18.7654 18.8478C19.2554 18.6448 19.6448 18.2554 19.8478 17.7654C20 17.3978 20 16.9319 20 16Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CampaignIconSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V15.2C12 16.8802 12 17.7202 12.327 18.362C12.6146 18.9265 13.0735 19.3854 13.638 19.673C14.2798 20 15.1198 20 16.8 20H17M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18C17.8954 18 17 18.8954 17 20ZM7 4L17 4M7 4C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4C3 2.89543 3.89543 2 5 2C6.10457 2 7 2.89543 7 4ZM17 4C17 5.10457 17.8954 6 19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4ZM12 12H17M17 12C17 13.1046 17.8954 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export function CheckmarkSVG() {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 11L10 14L16 8M21.5 11C21.5 16.5228 17.0228 21 11.5 21C5.97715 21 1.5 16.5228 1.5 11C1.5 5.47715 5.97715 1 11.5 1C17.0228 1 21.5 5.47715 21.5 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckmarkSVGlg() {
  return (
    <svg
      width="43"
      height="42"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 11L10 14L16 8M21.5 11C21.5 16.5228 17.0228 21 11.5 21C5.97715 21 1.5 16.5228 1.5 11C1.5 5.47715 5.97715 1 11.5 1C17.0228 1 21.5 5.47715 21.5 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckmarkSVGsm() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 11L10 14L16 8M21.5 11C21.5 16.5228 17.0228 21 11.5 21C5.97715 21 1.5 16.5228 1.5 11C1.5 5.47715 5.97715 1 11.5 1C17.0228 1 21.5 5.47715 21.5 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GreenCheckmarkSVG() {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 11L10 14L16 8M21.5 11C21.5 16.5228 17.0228 21 11.5 21C5.97715 21 1.5 16.5228 1.5 11C1.5 5.47715 5.97715 1 11.5 1C17.0228 1 21.5 5.47715 21.5 11Z"
        stroke="#50FB81"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const AlertSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
        stroke="#FFE458"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRightSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="#50FB81"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ArrowRightWhiteSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="#fff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ArrowRightBlackSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RocketSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15L9 12M12 15C13.3968 14.4687 14.7369 13.7987 16 13M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13M9 12C9.53214 10.6194 10.2022 9.29607 11 8.05C12.1652 6.18699 13.7876 4.65305 15.713 3.5941C17.6384 2.53514 19.8027 1.98637 22 2C22 4.72 21.22 9.5 16 13M9 12H4C4 12 4.55 8.97 6 8C7.62 6.92 11 8 11 8M4.5 16.5C3 17.76 2.5 21.5 2.5 21.5C2.5 21.5 6.24 21 7.5 19.5C8.21 18.66 8.2 17.37 7.41 16.59C7.02131 16.219 6.50929 16.0046 5.97223 15.988C5.43516 15.9714 4.91088 16.1537 4.5 16.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileSVG = () => {
  return (
    <svg
      // className="activity_profile_photo"
      width="55"
      height="55"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0.666504C6.63996 0.666504 0.666626 6.63984 0.666626 13.9998C0.666626 21.3598 6.63996 27.3332 14 27.3332C21.36 27.3332 27.3333 21.3598 27.3333 13.9998C27.3333 6.63984 21.36 0.666504 14 0.666504ZM14 4.6665C16.2133 4.6665 18 6.45317 18 8.6665C18 10.8798 16.2133 12.6665 14 12.6665C11.7866 12.6665 9.99996 10.8798 9.99996 8.6665C9.99996 6.45317 11.7866 4.6665 14 4.6665ZM14 23.5998C10.6666 23.5998 7.71996 21.8932 5.99996 19.3065C6.03996 16.6532 11.3333 15.1998 14 15.1998C16.6533 15.1998 21.96 16.6532 22 19.3065C20.28 21.8932 17.3333 23.5998 14 23.5998Z"
        fill="black"
      />
    </svg>
  );
};

export const AppStoreSVG = () => {
  return (
    <svg
      width="126"
      height="36"
      viewBox="0 0 126 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M125.3 31.8486C125.3 33.7671 123.696 35.3211 121.712 35.3211H4.2929C2.30985 35.3211 0.700195 33.7671 0.700195 31.8486V4.15659C0.700195 2.23901 2.30985 0.679565 4.2929 0.679565H121.711C123.696 0.679565 125.299 2.23901 125.299 4.15659L125.3 31.8486Z"
        fill="white"
      />
      <path
        d="M121.333 0.721186C123.494 0.721186 125.252 2.41656 125.252 4.50006V31.5001C125.252 33.5836 123.494 35.2789 121.333 35.2789H4.66667C2.506 35.2789 0.747833 33.5836 0.747833 31.5001V4.50006C0.747833 2.41656 2.506 0.721186 4.66667 0.721186H121.333ZM121.333 6.29377e-05H4.66667C2.10117 6.29377e-05 0 2.02619 0 4.50006V31.5001C0 33.9739 2.10117 36.0001 4.66667 36.0001H121.333C123.899 36.0001 126 33.9739 126 31.5001V4.50006C126 2.02619 123.899 6.29377e-05 121.333 6.29377e-05Z"
        fill="#A6A6A6"
      />
      <path
        d="M28.1198 17.8058C28.0927 14.9051 30.5829 13.4939 30.6967 13.4282C29.2865 11.4455 27.1006 11.1746 26.3325 11.153C24.4966 10.9667 22.7158 12.2123 21.7806 12.2123C20.8267 12.2123 19.3866 11.171 17.8345 11.2016C15.8371 11.2313 13.9686 12.3464 12.9438 14.078C10.8289 17.6087 12.4062 22.7972 14.4325 25.6511C15.4461 27.0488 16.6305 28.6094 18.1807 28.5545C19.6974 28.4942 20.2639 27.6221 22.0942 27.6221C23.9077 27.6221 24.4397 28.5545 26.0207 28.5194C27.6485 28.4942 28.6733 27.1154 29.6514 25.7051C30.8227 24.1031 31.2931 22.5254 31.3118 22.4444C31.2735 22.4318 28.1506 21.2825 28.1198 17.8058Z"
        fill="black"
      />
      <path
        d="M25.1331 9.27562C25.9489 8.29192 26.507 6.95362 26.3521 5.59552C25.1714 5.64592 23.6949 6.38302 22.8446 7.34512C22.0923 8.19292 21.4203 9.58252 21.5939 10.8893C22.9202 10.9847 24.2819 10.244 25.1331 9.27562Z"
        fill="black"
      />
      <path
        d="M45.7804 9.00857C45.7804 10.0679 45.4509 10.8653 44.7929 11.4008C44.1835 11.8949 43.3173 12.1424 42.1955 12.1424C41.6392 12.1424 41.1632 12.119 40.7646 12.0722V6.28426C41.2845 6.20326 41.8445 6.16187 42.4493 6.16187C43.518 6.16187 44.3235 6.38597 44.8667 6.83417C45.4752 7.34087 45.7804 8.06537 45.7804 9.00857ZM44.7491 9.03467C44.7491 8.34797 44.5605 7.82146 44.1835 7.45426C43.8064 7.08796 43.2557 6.90437 42.5305 6.90437C42.2225 6.90437 41.9602 6.92417 41.7428 6.96557V11.3657C41.8632 11.3837 42.0835 11.3918 42.4036 11.3918C43.1521 11.3918 43.7299 11.1911 44.1368 10.7897C44.5437 10.3883 44.7491 9.80327 44.7491 9.03467Z"
        fill="black"
      />
      <path
        d="M51.2487 9.93359C51.2487 10.5861 51.0555 11.1207 50.6691 11.5401C50.264 11.9712 49.7273 12.1863 49.0572 12.1863C48.4113 12.1863 47.8971 11.9802 47.5135 11.5662C47.1308 11.1531 46.9395 10.632 46.9395 10.0038C46.9395 9.34679 47.1364 8.80769 47.5321 8.38919C47.9279 7.97069 48.4599 7.76099 49.13 7.76099C49.7759 7.76099 50.2948 7.96709 50.6877 8.38019C51.0611 8.78159 51.2487 9.29999 51.2487 9.93359ZM50.2341 9.96419C50.2341 9.57269 50.1464 9.23699 49.9719 8.95709C49.7665 8.61869 49.4744 8.44949 49.0945 8.44949C48.7016 8.44949 48.4029 8.61869 48.1976 8.95709C48.0221 9.23699 47.9353 9.57809 47.9353 9.98129C47.9353 10.3728 48.0231 10.7085 48.1976 10.9884C48.4095 11.3268 48.7044 11.496 49.0852 11.496C49.4585 11.496 49.7516 11.3241 49.9625 10.9794C50.1436 10.6941 50.2341 10.3557 50.2341 9.96419Z"
        fill="black"
      />
      <path
        d="M58.5807 7.8476L57.2041 12.0902H56.3081L55.7378 10.2479C55.5931 9.78799 55.4755 9.3308 55.3841 8.8772H55.3663C55.2814 9.3434 55.1638 9.79969 55.0126 10.2479L54.4069 12.0902H53.5006L52.2061 7.8476H53.2113L53.7087 9.8645C53.8291 10.3415 53.9281 10.796 54.0074 11.2262H54.0251C54.0979 10.8716 54.2183 10.4198 54.3882 9.8735L55.0126 7.8485H55.8097L56.4079 9.8303C56.5526 10.3136 56.6702 10.7789 56.7607 11.2271H56.7878C56.8541 10.7906 56.9539 10.3253 57.0865 9.8303L57.6203 7.8485H58.5807V7.8476Z"
        fill="black"
      />
      <path
        d="M63.6514 12.0898H62.6733V9.65976C62.6733 8.91096 62.3784 8.53656 61.7866 8.53656C61.4964 8.53656 61.2621 8.63916 61.0801 8.84526C60.9 9.05136 60.8085 9.29436 60.8085 9.57246V12.0889H59.8304V9.05946C59.8304 8.68686 59.8183 8.28276 59.7949 7.84536H60.6545L60.7003 8.50866H60.7273C60.8412 8.30256 61.0111 8.13246 61.2341 7.99656C61.4992 7.83816 61.796 7.75806 62.1208 7.75806C62.5314 7.75806 62.873 7.88586 63.1446 8.14236C63.4825 8.45646 63.6514 8.92536 63.6514 9.54816V12.0898Z"
        fill="black"
      />
      <path
        d="M66.3493 12.0899H65.3721V5.90057H66.3493V12.0899Z"
        fill="black"
      />
      <path
        d="M72.108 9.93359C72.108 10.5861 71.9148 11.1207 71.5284 11.5401C71.1234 11.9712 70.5858 12.1863 69.9166 12.1863C69.2698 12.1863 68.7555 11.9802 68.3728 11.5662C67.9902 11.1531 67.7988 10.632 67.7988 10.0038C67.7988 9.34679 67.9958 8.80769 68.3915 8.38919C68.7872 7.97069 69.3192 7.76099 69.9884 7.76099C70.6352 7.76099 71.1532 7.96709 71.5471 8.38019C71.9204 8.78159 72.108 9.29999 72.108 9.93359ZM71.0926 9.96419C71.0926 9.57269 71.0048 9.23699 70.8303 8.95709C70.6259 8.61869 70.3328 8.44949 69.9539 8.44949C69.56 8.44949 69.2614 8.61869 69.057 8.95709C68.8815 9.23699 68.7947 9.57809 68.7947 9.98129C68.7947 10.3728 68.8824 10.7085 69.057 10.9884C69.2688 11.3268 69.5638 11.496 69.9446 11.496C70.3179 11.496 70.61 11.3241 70.821 10.9794C71.003 10.6941 71.0926 10.3557 71.0926 9.96419Z"
        fill="black"
      />
      <path
        d="M76.8415 12.09H75.9632L75.8904 11.6013H75.8634C75.5628 11.991 75.1344 12.1863 74.5782 12.1863C74.1628 12.1863 73.8268 12.0576 73.5739 11.802C73.3443 11.5698 73.2295 11.2809 73.2295 10.938C73.2295 10.4196 73.4535 10.0245 73.9043 9.75089C74.3542 9.47729 74.987 9.34319 75.8018 9.34949V9.27029C75.8018 8.71139 75.4975 8.43239 74.888 8.43239C74.454 8.43239 74.0714 8.53769 73.741 8.74649L73.5422 8.12729C73.951 7.88339 74.4559 7.76099 75.0514 7.76099C76.2012 7.76099 76.778 8.34599 76.778 9.51599V11.0784C76.778 11.5023 76.7995 11.8398 76.8415 12.09ZM75.826 10.632V9.97769C74.7471 9.95969 74.2076 10.245 74.2076 10.8327C74.2076 11.0541 74.2692 11.2197 74.3952 11.3304C74.5212 11.4411 74.6818 11.496 74.8731 11.496C75.0878 11.496 75.2884 11.4303 75.4714 11.2998C75.6552 11.1684 75.7682 11.0019 75.8102 10.7976C75.8204 10.7517 75.826 10.6959 75.826 10.632Z"
        fill="black"
      />
      <path
        d="M82.4002 12.0899H81.5322L81.4865 11.4086H81.4594C81.1822 11.927 80.7099 12.1862 80.0463 12.1862C79.5162 12.1862 79.0747 11.9855 78.7247 11.5841C78.3747 11.1827 78.2002 10.6616 78.2002 10.0217C78.2002 9.33497 78.3897 8.77877 78.7705 8.35397C79.1391 7.95797 79.5909 7.75997 80.1285 7.75997C80.7193 7.75997 81.1327 7.95167 81.3679 8.33597H81.3866V5.90057H82.3657V10.9469C82.3657 11.36 82.3769 11.7407 82.4002 12.0899ZM81.3866 10.3007V9.59327C81.3866 9.47087 81.3773 9.37187 81.3595 9.29627C81.3045 9.06947 81.1859 8.87867 81.0058 8.72477C80.8238 8.57087 80.6045 8.49347 80.3515 8.49347C79.9866 8.49347 79.701 8.63297 79.491 8.91287C79.2829 9.19277 79.1774 9.55007 79.1774 9.98657C79.1774 10.406 79.2773 10.7462 79.4779 11.0081C79.6898 11.2871 79.9754 11.4266 80.3329 11.4266C80.6539 11.4266 80.9106 11.3105 81.1057 11.0774C81.2942 10.8623 81.3866 10.6031 81.3866 10.3007Z"
        fill="black"
      />
      <path
        d="M90.7653 9.93359C90.7653 10.5861 90.5721 11.1207 90.1857 11.5401C89.7806 11.9712 89.2449 12.1863 88.5738 12.1863C87.9289 12.1863 87.4146 11.9802 87.0301 11.5662C86.6474 11.1531 86.4561 10.632 86.4561 10.0038C86.4561 9.34679 86.653 8.80769 87.0487 8.38919C87.4445 7.97069 87.9765 7.76099 88.6475 7.76099C89.2925 7.76099 89.8123 7.96709 90.2043 8.38019C90.5777 8.78159 90.7653 9.29999 90.7653 9.93359ZM89.7517 9.96419C89.7517 9.57269 89.6639 9.23699 89.4894 8.95709C89.2831 8.61869 88.9919 8.44949 88.6111 8.44949C88.2191 8.44949 87.9205 8.61869 87.7142 8.95709C87.5387 9.23699 87.4519 9.57809 87.4519 9.98129C87.4519 10.3728 87.5397 10.7085 87.7142 10.9884C87.9261 11.3268 88.221 11.496 88.6018 11.496C88.9751 11.496 89.2691 11.3241 89.4801 10.9794C89.6602 10.6941 89.7517 10.3557 89.7517 9.96419Z"
        fill="black"
      />
      <path
        d="M96.0245 12.0898H95.0473V9.65976C95.0473 8.91096 94.7524 8.53656 94.1597 8.53656C93.8695 8.53656 93.6352 8.63916 93.4541 8.84526C93.2731 9.05136 93.1825 9.29436 93.1825 9.57246V12.0889H92.2035V9.05946C92.2035 8.68686 92.1923 8.28276 92.1689 7.84536H93.0276L93.0733 8.50866H93.1004C93.2152 8.30256 93.3851 8.13246 93.6072 7.99656C93.8732 7.83816 94.1691 7.75806 94.4948 7.75806C94.9045 7.75806 95.2461 7.88586 95.5177 8.14236C95.8565 8.45646 96.0245 8.92536 96.0245 9.54816V12.0898Z"
        fill="black"
      />
      <path
        d="M102.607 8.55387H101.53V10.6149C101.53 11.1387 101.722 11.4006 102.101 11.4006C102.276 11.4006 102.422 11.3862 102.536 11.3565L102.562 12.072C102.368 12.1422 102.115 12.1773 101.802 12.1773C101.415 12.1773 101.115 12.0639 100.897 11.8371C100.679 11.6103 100.571 11.2287 100.571 10.6932V8.55387H99.9277V7.84737H100.571V7.06977L101.529 6.79077V7.84647H102.606V8.55387H102.607Z"
        fill="black"
      />
      <path
        d="M107.786 12.0899H106.807V9.67787C106.807 8.91737 106.512 8.53667 105.921 8.53667C105.468 8.53667 105.158 8.75717 104.988 9.19817C104.959 9.29087 104.942 9.40427 104.942 9.53747V12.089H103.965V5.90057H104.942V8.45747H104.961C105.269 7.99217 105.71 7.75997 106.282 7.75997C106.687 7.75997 107.022 7.88777 107.288 8.14427C107.62 8.46377 107.786 8.93897 107.786 9.56717V12.0899Z"
        fill="black"
      />
      <path
        d="M113.126 9.76803C113.126 9.93723 113.113 10.0794 113.09 10.1955H110.157C110.17 10.6149 110.31 10.9344 110.581 11.1558C110.83 11.3538 111.15 11.4528 111.542 11.4528C111.976 11.4528 112.371 11.3862 112.728 11.2521L112.881 11.9073C112.464 12.0819 111.973 12.1692 111.404 12.1692C110.723 12.1692 110.186 11.9757 109.798 11.5887C109.408 11.2017 109.215 10.6824 109.215 10.0308C109.215 9.39093 109.395 8.85813 109.758 8.43333C110.137 7.97973 110.649 7.75293 111.296 7.75293C111.929 7.75293 112.41 7.97973 112.734 8.43333C112.997 8.79333 113.126 9.23883 113.126 9.76803ZM112.193 9.52413C112.201 9.24423 112.136 9.00303 112.004 8.79963C111.834 8.53773 111.575 8.40633 111.225 8.40633C110.906 8.40633 110.646 8.53413 110.447 8.79063C110.284 8.99493 110.188 9.23883 110.157 9.52413H112.193Z"
        fill="black"
      />
      <path
        d="M50.068 28.3532H47.9484L46.7874 24.8351H42.7516L41.6456 28.3532H39.582L43.5804 16.376H46.05L50.068 28.3532ZM46.4374 23.3591L45.3874 20.2316C45.2763 19.9121 45.0682 19.1597 44.7611 17.9753H44.7238C44.6015 18.4847 44.4046 19.2371 44.1339 20.2316L43.1026 23.3591H46.4374Z"
        fill="black"
      />
      <path
        d="M60.3505 23.9292C60.3505 25.398 59.9389 26.559 59.1157 27.4113C58.3784 28.17 57.4628 28.5489 56.3699 28.5489C55.1901 28.5489 54.3427 28.1403 53.8265 27.3231H53.7892V31.8726H51.7993V22.5603C51.7993 21.6369 51.7741 20.6892 51.7256 19.7172H53.4756L53.5867 21.0861H53.624C54.2876 20.0547 55.2947 19.5399 56.6461 19.5399C57.7027 19.5399 58.5847 19.9422 59.2903 20.7477C59.9977 21.5541 60.3505 22.6143 60.3505 23.9292ZM58.3233 23.9994C58.3233 23.1588 58.1273 22.4658 57.7335 21.9204C57.3032 21.3516 56.7254 21.0672 56.0012 21.0672C55.5102 21.0672 55.0641 21.2256 54.6656 21.5379C54.2661 21.8529 54.0048 22.2642 53.8825 22.7736C53.8209 23.0112 53.7901 23.2056 53.7901 23.3586V24.7986C53.7901 25.4268 53.9899 25.9569 54.3893 26.3898C54.7888 26.8227 55.3077 27.0387 55.9461 27.0387C56.6956 27.0387 57.2789 26.7597 57.6961 26.2035C58.1143 25.6464 58.3233 24.912 58.3233 23.9994Z"
        fill="black"
      />
      <path
        d="M70.6523 23.9292C70.6523 25.398 70.2407 26.559 69.4166 27.4113C68.6802 28.17 67.7646 28.5489 66.6717 28.5489C65.4919 28.5489 64.6445 28.1403 64.1293 27.3231H64.0919V31.8726H62.1021V22.5603C62.1021 21.6369 62.0769 20.6892 62.0283 19.7172H63.7783L63.8894 21.0861H63.9267C64.5894 20.0547 65.5965 19.5399 66.9489 19.5399C68.0045 19.5399 68.8865 19.9422 69.5939 20.7477C70.2986 21.5541 70.6523 22.6143 70.6523 23.9292ZM68.6251 23.9994C68.6251 23.1588 68.4282 22.4658 68.0343 21.9204C67.6041 21.3516 67.0282 21.0672 66.303 21.0672C65.8111 21.0672 65.3659 21.2256 64.9665 21.5379C64.567 21.8529 64.3066 22.2642 64.1843 22.7736C64.1237 23.0112 64.0919 23.2056 64.0919 23.3586V24.7986C64.0919 25.4268 64.2917 25.9569 64.6893 26.3898C65.0887 26.8218 65.6077 27.0387 66.2479 27.0387C66.9974 27.0387 67.5807 26.7597 67.9979 26.2035C68.4161 25.6464 68.6251 24.912 68.6251 23.9994Z"
        fill="black"
      />
      <path
        d="M82.1685 24.9945C82.1685 26.0133 81.8017 26.8422 81.0653 27.4821C80.2561 28.1814 79.1296 28.5306 77.682 28.5306C76.3454 28.5306 75.274 28.2822 74.4629 27.7845L74.924 26.1852C75.7976 26.6946 76.7561 26.9502 77.8005 26.9502C78.55 26.9502 79.1333 26.7864 79.5524 26.4606C79.9696 26.1348 80.1777 25.6974 80.1777 25.152C80.1777 24.666 80.006 24.2565 79.6616 23.9244C79.319 23.5923 78.7469 23.2836 77.948 22.9983C75.7733 22.2162 74.6869 21.0705 74.6869 19.5639C74.6869 18.5793 75.0677 17.772 75.8302 17.1438C76.59 16.5147 77.6036 16.2006 78.871 16.2006C80.0013 16.2006 80.9402 16.3905 81.6897 16.7694L81.1922 18.3336C80.4922 17.9664 79.7008 17.7828 78.815 17.7828C78.115 17.7828 77.5681 17.9493 77.1761 18.2805C76.8448 18.5766 76.6786 18.9375 76.6786 19.365C76.6786 19.8384 76.8681 20.2299 77.2489 20.5377C77.5802 20.8221 78.1822 21.1299 79.0558 21.462C80.1245 21.8769 80.9094 22.362 81.4144 22.9182C81.9174 23.4726 82.1685 24.1665 82.1685 24.9945Z"
        fill="black"
      />
      <path
        d="M88.7483 21.1568H86.555V25.3499C86.555 26.4164 86.9414 26.9492 87.7161 26.9492C88.0717 26.9492 88.3666 26.9195 88.5999 26.8601L88.655 28.3172C88.263 28.4585 87.7469 28.5296 87.1075 28.5296C86.3217 28.5296 85.7075 28.2983 85.2642 27.8366C84.8227 27.374 84.6006 26.5982 84.6006 25.5083V21.155H83.2939V19.715H84.6006V18.1337L86.555 17.5649V19.715H88.7483V21.1568Z"
        fill="black"
      />
      <path
        d="M98.6445 23.9641C98.6445 25.2916 98.2506 26.3815 97.4647 27.2338C96.6406 28.1113 95.5467 28.5487 94.1831 28.5487C92.869 28.5487 91.8227 28.1284 91.0425 27.2878C90.2622 26.4472 89.8721 25.3861 89.8721 24.1072C89.8721 22.7689 90.2734 21.6727 91.0789 20.8204C91.8825 19.9672 92.967 19.5406 94.3306 19.5406C95.6447 19.5406 96.7022 19.9609 97.5002 20.8024C98.2637 21.6187 98.6445 22.6726 98.6445 23.9641ZM96.5799 24.0262C96.5799 23.2297 96.4035 22.5466 96.0461 21.9769C95.6289 21.2875 95.0325 20.9437 94.2597 20.9437C93.4598 20.9437 92.8522 21.2884 92.435 21.9769C92.0775 22.5475 91.9011 23.2414 91.9011 24.0622C91.9011 24.8587 92.0775 25.5418 92.435 26.1106C92.8653 26.8 93.4663 27.1438 94.2419 27.1438C95.0017 27.1438 95.5981 26.7928 96.0283 26.0926C96.3951 25.5121 96.5799 24.8218 96.5799 24.0262Z"
        fill="black"
      />
      <path
        d="M105.112 21.4047C104.915 21.3696 104.705 21.3516 104.485 21.3516C103.785 21.3516 103.244 21.6063 102.863 22.1166C102.531 22.5666 102.365 23.1354 102.365 23.8221V28.3536H100.376L100.395 22.437C100.395 21.4416 100.37 20.5353 100.32 19.7181H102.054L102.126 21.3705H102.181C102.391 20.8026 102.723 20.3454 103.176 20.0025C103.62 19.6938 104.098 19.5399 104.615 19.5399C104.798 19.5399 104.965 19.5525 105.112 19.575V21.4047Z"
        fill="black"
      />
      <path
        d="M114.011 23.6268C114.011 23.9706 113.988 24.2604 113.938 24.4971H107.969C107.992 25.3503 108.281 26.0028 108.835 26.4528C109.338 26.8551 109.989 27.0567 110.787 27.0567C111.671 27.0567 112.478 26.9208 113.203 26.6481L113.515 27.9801C112.667 28.3365 111.667 28.5138 110.512 28.5138C109.123 28.5138 108.033 28.1196 107.24 27.3321C106.448 26.5446 106.052 25.4871 106.052 24.1605C106.052 22.8582 106.42 21.7737 107.159 20.9088C107.931 19.9854 108.976 19.5237 110.29 19.5237C111.581 19.5237 112.558 19.9854 113.222 20.9088C113.747 21.6423 114.011 22.5495 114.011 23.6268ZM112.114 23.1291C112.127 22.5603 111.997 22.0689 111.727 21.654C111.383 21.1203 110.854 20.8539 110.142 20.8539C109.491 20.8539 108.962 21.114 108.558 21.636C108.226 22.0509 108.029 22.5486 107.969 23.1282H112.114V23.1291Z"
        fill="black"
      />
    </svg>
  );
};
export const PlayStoreSVG = () => {
  return (
    <svg
      width="126"
      height="36"
      viewBox="0 0 126 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M121.332 36H4.66569C2.10019 36 -0.000976562 33.9739 -0.000976562 31.5V4.5C-0.000976562 2.02613 2.10019 1.90258e-06 4.66569 1.90258e-06H121.332C123.898 1.90258e-06 125.999 2.02613 125.999 4.5V31.5C125.999 33.9739 123.898 36 121.332 36Z"
        fill="white"
      />
      <path
        d="M121.332 0.721125C123.493 0.721125 125.251 2.4165 125.251 4.5V31.5C125.251 33.5835 123.493 35.2789 121.332 35.2789H4.66569C2.50502 35.2789 0.746856 33.5835 0.746856 31.5V4.5C0.746856 2.4165 2.50502 0.721125 4.66569 0.721125H121.332ZM121.332 1.90258e-06H4.66569C2.10019 1.90258e-06 -0.000976562 2.02613 -0.000976562 4.5V31.5C-0.000976562 33.9739 2.10019 36 4.66569 36H121.332C123.898 36 125.999 33.9739 125.999 31.5V4.5C125.999 2.02613 123.898 1.90258e-06 121.332 1.90258e-06Z"
        fill="#A6A6A6"
      />
      <path
        d="M9.03928 6.78502C8.76511 7.06177 8.60645 7.49264 8.60645 8.05064V27.9541C8.60645 28.5121 8.76511 28.943 9.03928 29.2198L9.10694 29.2805L20.6733 18.1318V17.8685L9.10694 6.71977L9.03928 6.78502Z"
        fill="black"
      />
      <path
        d="M25.9244 21.8505L22.0732 18.1324V17.8691L25.9291 14.151L26.0154 14.1994L30.5817 16.7048C31.8849 17.4158 31.8849 18.5858 30.5817 19.3013L26.0154 21.8021L25.9244 21.8505Z"
        fill="black"
      />
      <path
        d="M25.3154 22.4942L21.3733 18.6928L9.73926 29.9124C10.1721 30.3512 10.8779 30.404 11.6806 29.9653L25.3154 22.4942Z"
        fill="black"
      />
      <path
        d="M25.3154 13.507L11.6806 6.03591C10.8779 5.60166 10.1721 5.65454 9.73926 6.09329L21.3733 17.3084L25.3154 13.507Z"
        fill="black"
      />
      <path
        d="M44.2554 9.21922C44.2554 9.97072 44.0221 10.5726 43.5624 11.0215C43.0339 11.5536 42.3456 11.8213 41.5021 11.8213C40.6959 11.8213 40.0076 11.5491 39.4429 11.0125C38.8771 10.468 38.5947 9.79972 38.5947 8.99984C38.5947 8.19997 38.8771 7.53172 39.4429 6.99172C40.0076 6.4506 40.6959 6.17834 41.5021 6.17834C41.9034 6.17834 42.2861 6.25822 42.6512 6.40672C43.0152 6.55634 43.3116 6.75884 43.5262 7.00859L43.0386 7.48335C42.6641 7.05697 42.1542 6.8466 41.5021 6.8466C40.9141 6.8466 40.4042 7.04459 39.9714 7.44397C39.5432 7.84447 39.3286 8.36309 39.3286 8.99984C39.3286 9.63659 39.5432 10.1597 39.9714 10.5602C40.4042 10.9551 40.9141 11.1576 41.5021 11.1576C42.1262 11.1576 42.6512 10.9551 43.0654 10.5557C43.3384 10.2913 43.4936 9.92684 43.5344 9.46109H41.5021V8.81084H44.2134C44.2461 8.95147 44.2554 9.08759 44.2554 9.21922Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M48.5569 6.96499H46.0101V8.67499H48.3061V9.32524H46.0101V11.0352H48.5569V11.6979H45.2891V6.30237H48.5569V6.96499Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M51.5927 11.6979H50.8717V6.96499H49.3096V6.30237H53.1561V6.96499H51.5927V11.6979Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M55.9395 11.6979V6.30237H56.6593V11.6979H55.9395Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M59.8505 11.6979H59.1354V6.96499H57.5674V6.30237H61.4185V6.96499H59.8505V11.6979Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M68.701 11.0035C68.1492 11.5491 67.4655 11.8213 66.65 11.8213C65.8299 11.8213 65.1462 11.5491 64.5944 11.0035C64.0437 10.459 63.7695 9.79072 63.7695 8.99984C63.7695 8.20897 64.0437 7.54072 64.5944 6.99622C65.1462 6.45059 65.8299 6.17834 66.65 6.17834C67.4609 6.17834 68.1445 6.45059 68.6964 7.00072C69.2517 7.54972 69.5259 8.21347 69.5259 8.99984C69.5259 9.79072 69.2517 10.459 68.701 11.0035ZM65.1275 10.5512C65.5429 10.9551 66.048 11.1576 66.65 11.1576C67.2474 11.1576 67.7572 10.9551 68.1679 10.5512C68.582 10.1473 68.792 9.62872 68.792 8.99984C68.792 8.37097 68.582 7.85235 68.1679 7.44847C67.7572 7.0446 67.2474 6.84209 66.65 6.84209C66.048 6.84209 65.5429 7.0446 65.1275 7.44847C64.7134 7.85235 64.5034 8.37097 64.5034 8.99984C64.5034 9.62872 64.7134 10.1473 65.1275 10.5512Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M70.5371 11.6979V6.30237H71.4121L74.1328 10.4986H74.1643L74.1328 9.46137V6.30237H74.8526V11.6979H74.1013L71.2523 7.29462H71.2208L71.2523 8.33637V11.6979H70.5371Z"
        fill="black"
        stroke="black"
        strokeWidth="0.173333"
        strokeMiterlimit="10"
      />
      <path
        d="M63.5924 19.5772C61.4002 19.5772 59.6094 21.1859 59.6094 23.4056C59.6094 25.6072 61.4002 27.2328 63.5924 27.2328C65.7892 27.2328 67.58 25.6072 67.58 23.4056C67.58 21.1859 65.7892 19.5772 63.5924 19.5772ZM63.5924 25.7253C62.3895 25.7253 61.3547 24.7679 61.3547 23.4056C61.3547 22.0252 62.3895 21.0847 63.5924 21.0847C64.7952 21.0847 65.8347 22.0252 65.8347 23.4056C65.8347 24.7679 64.7952 25.7253 63.5924 25.7253ZM54.9019 19.5772C52.705 19.5772 50.9189 21.1859 50.9189 23.4056C50.9189 25.6072 52.705 27.2328 54.9019 27.2328C57.0975 27.2328 58.8849 25.6072 58.8849 23.4056C58.8849 21.1859 57.0975 19.5772 54.9019 19.5772ZM54.9019 25.7253C53.6979 25.7253 52.6595 24.7679 52.6595 23.4056C52.6595 22.0252 53.6979 21.0847 54.9019 21.0847C56.1047 21.0847 57.1395 22.0252 57.1395 23.4056C57.1395 24.7679 56.1047 25.7253 54.9019 25.7253ZM44.5605 20.7506V22.3773H48.589C48.4712 23.2863 48.1562 23.9546 47.6732 24.4203C47.0852 24.9828 46.1694 25.6072 44.5605 25.6072C42.0814 25.6072 40.14 23.6778 40.14 21.2872C40.14 18.8966 42.0814 16.9672 44.5605 16.9672C45.901 16.9672 46.8764 17.4723 47.5962 18.1271L48.785 16.9807C47.7782 16.0537 46.4389 15.3416 44.5605 15.3416C41.1609 15.3416 38.3037 18.0089 38.3037 21.2872C38.3037 24.5654 41.1609 27.2328 44.5605 27.2328C46.398 27.2328 47.7782 26.6523 48.8632 25.5633C49.975 24.4912 50.3215 22.9837 50.3215 21.7664C50.3215 21.3884 50.2889 21.0408 50.2305 20.7506H44.5605ZM86.8475 22.0117C86.5197 21.1556 85.5082 19.5772 83.4479 19.5772C81.4062 19.5772 79.7064 21.1286 79.7064 23.4056C79.7064 25.5498 81.3887 27.2328 83.6439 27.2328C85.4674 27.2328 86.5197 26.1607 86.9525 25.5363L85.5992 24.6667C85.1477 25.3034 84.5329 25.7253 83.6439 25.7253C82.7607 25.7253 82.1272 25.3349 81.7212 24.5654L87.0307 22.4471L86.8475 22.0117ZM81.4342 23.2863C81.3887 21.8103 82.623 21.0543 83.5074 21.0543C84.2004 21.0543 84.7884 21.3884 84.9844 21.8666L81.4342 23.2863ZM77.1187 26.9999H78.864V15.7499H77.1187V26.9999ZM74.2604 20.4299H74.202C73.81 19.9822 73.0622 19.5772 72.1149 19.5772C70.1269 19.5772 68.3092 21.2602 68.3092 23.4179C68.3092 25.5633 70.1269 27.2328 72.1149 27.2328C73.0622 27.2328 73.81 26.8244 74.202 26.3632H74.2604V26.9122C74.2604 28.3758 73.4495 29.1622 72.1417 29.1622C71.0754 29.1622 70.4139 28.4197 70.1409 27.7953L68.623 28.4062C69.0605 29.4209 70.219 30.6697 72.1417 30.6697C74.188 30.6697 75.9147 29.5087 75.9147 26.6838V19.8101H74.2604V20.4299ZM72.2642 25.7253C71.0614 25.7253 70.0545 24.7544 70.0545 23.4179C70.0545 22.0691 71.0614 21.0847 72.2642 21.0847C73.4495 21.0847 74.384 22.0691 74.384 23.4179C74.384 24.7544 73.4495 25.7253 72.2642 25.7253ZM95.0189 15.7499H90.8445V26.9999H92.5852V22.7373H95.0189C96.952 22.7373 98.8479 21.3884 98.8479 19.2431C98.8479 17.0988 96.9474 15.7499 95.0189 15.7499ZM95.0644 21.1724H92.5852V17.3148H95.0644C96.364 17.3148 97.106 18.3554 97.106 19.2431C97.106 20.1138 96.364 21.1724 95.0644 21.1724ZM105.825 19.5558C104.567 19.5558 103.259 20.0913 102.721 21.2782L104.266 21.9026C104.598 21.2782 105.21 21.0757 105.856 21.0757C106.759 21.0757 107.675 21.5988 107.689 22.5224V22.6406C107.374 22.4651 106.7 22.2052 105.87 22.2052C104.206 22.2052 102.511 23.0883 102.511 24.7364C102.511 26.2439 103.874 27.2148 105.406 27.2148C106.577 27.2148 107.223 26.7052 107.629 26.1123H107.689V26.9819H109.37V22.6664C109.37 20.6718 107.825 19.5558 105.825 19.5558ZM105.615 25.7208C105.045 25.7208 104.252 25.4486 104.252 24.7679C104.252 23.8972 105.241 23.5631 106.098 23.5631C106.864 23.5631 107.223 23.7262 107.689 23.9411C107.552 24.9828 106.623 25.7208 105.615 25.7208ZM115.495 19.8022L113.494 24.6791H113.435L111.366 19.8022H109.489L112.597 26.6174L110.824 30.4098H112.643L117.432 19.8022H115.495ZM99.8045 26.9999H101.55V15.7499H99.8045V26.9999Z"
        fill="black"
      />
    </svg>
  );
};

export const BullIndication = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.13398 0.499999C7.51888 -0.166668 8.48112 -0.166667 8.86602 0.5L14.9282 11C15.3131 11.6667 14.832 12.5 14.0622 12.5L1.93782 12.5C1.16802 12.5 0.686897 11.6667 1.0718 11L7.13398 0.499999Z"
        fill="#41C667"
      />
    </svg>
  );
};
export const BearIndication = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.86603 12.5C8.48112 13.1667 7.51888 13.1667 7.13398 12.5L1.0718 2C0.686898 1.33333 1.16802 0.499999 1.93782 0.499999L14.0622 0.5C14.832 0.5 15.3131 1.33333 14.9282 2L8.86603 12.5Z"
        fill="#ED431D"
      />
    </svg>
  );
};

export const CloseMediaSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseBlackSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseBlackSmSVG = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HappySVG = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5026 5.9987H10.5093M6.5026 5.9987H6.50927M15.1693 7.9987C15.1693 11.6806 12.1845 14.6654 8.5026 14.6654C4.82071 14.6654 1.83594 11.6806 1.83594 7.9987C1.83594 4.3168 4.82071 1.33203 8.5026 1.33203C12.1845 1.33203 15.1693 4.3168 15.1693 7.9987ZM10.8359 5.9987C10.8359 6.18279 10.6867 6.33203 10.5026 6.33203C10.3185 6.33203 10.1693 6.18279 10.1693 5.9987C10.1693 5.8146 10.3185 5.66536 10.5026 5.66536C10.6867 5.66536 10.8359 5.8146 10.8359 5.9987ZM6.83594 5.9987C6.83594 6.18279 6.6867 6.33203 6.5026 6.33203C6.31851 6.33203 6.16927 6.18279 6.16927 5.9987C6.16927 5.8146 6.31851 5.66536 6.5026 5.66536C6.6867 5.66536 6.83594 5.8146 6.83594 5.9987ZM8.5026 11.6654C10.1696 11.6654 11.5026 10.4434 11.5026 9.33203H5.5026C5.5026 10.4434 6.8356 11.6654 8.5026 11.6654Z"
        stroke="#41C667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NeuralSVG = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4139_128934)">
        <path
          d="M6.17188 9.9987H11.5052M10.8385 5.9987H10.8452M6.83854 5.9987H6.84521M15.5052 7.9987C15.5052 11.6806 12.5204 14.6654 8.83854 14.6654C5.15664 14.6654 2.17188 11.6806 2.17188 7.9987C2.17188 4.3168 5.15664 1.33203 8.83854 1.33203C12.5204 1.33203 15.5052 4.3168 15.5052 7.9987ZM11.1719 5.9987C11.1719 6.18279 11.0226 6.33203 10.8385 6.33203C10.6544 6.33203 10.5052 6.18279 10.5052 5.9987C10.5052 5.8146 10.6544 5.66536 10.8385 5.66536C11.0226 5.66536 11.1719 5.8146 11.1719 5.9987ZM7.17188 5.9987C7.17188 6.18279 7.02264 6.33203 6.83854 6.33203C6.65445 6.33203 6.50521 6.18279 6.50521 5.9987C6.50521 5.8146 6.65445 5.66536 6.83854 5.66536C7.02264 5.66536 7.17188 5.8146 7.17188 5.9987Z"
          stroke="#FFDD85"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4139_128934">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.835938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SadSVG = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8411 10.6654C10.8411 10.6654 9.84115 9.33203 8.17448 9.33203C6.50781 9.33203 5.50781 10.6654 5.50781 10.6654M11.5078 6.1587C11.2445 6.48203 10.8845 6.66536 10.5078 6.66536C10.1311 6.66536 9.78115 6.48203 9.50781 6.1587M6.84115 6.1587C6.57781 6.48203 6.21781 6.66536 5.84115 6.66536C5.46448 6.66536 5.11448 6.48203 4.84115 6.1587M14.8411 7.9987C14.8411 11.6806 11.8564 14.6654 8.17448 14.6654C4.49258 14.6654 1.50781 11.6806 1.50781 7.9987C1.50781 4.3168 4.49258 1.33203 8.17448 1.33203C11.8564 1.33203 14.8411 4.3168 14.8411 7.9987Z"
        stroke="#ED431D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SadBigSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8411 10.6654C10.8411 10.6654 9.84115 9.33203 8.17448 9.33203C6.50781 9.33203 5.50781 10.6654 5.50781 10.6654M11.5078 6.1587C11.2445 6.48203 10.8845 6.66536 10.5078 6.66536C10.1311 6.66536 9.78115 6.48203 9.50781 6.1587M6.84115 6.1587C6.57781 6.48203 6.21781 6.66536 5.84115 6.66536C5.46448 6.66536 5.11448 6.48203 4.84115 6.1587M14.8411 7.9987C14.8411 11.6806 11.8564 14.6654 8.17448 14.6654C4.49258 14.6654 1.50781 11.6806 1.50781 7.9987C1.50781 4.3168 4.49258 1.33203 8.17448 1.33203C11.8564 1.33203 14.8411 4.3168 14.8411 7.9987Z"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VideosSVG = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22V2M7 22V17M7 7V2M17 22V17M17 7V2M2 7H22M2 17H22M22 17.2V6.8C22 5.11984 22 4.27976 21.673 3.63803C21.3854 3.07354 20.9265 2.6146 20.362 2.32698C19.7202 2 18.8802 2 17.2 2L6.8 2C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8L2 17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H17.2C18.8802 22 19.7202 22 20.362 21.673C20.9265 21.3854 21.3854 20.9265 21.673 20.362C22 19.7202 22 18.8802 22 17.2Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersSVG = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoOfViewsSVG = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.61342 6.47415C1.52262 6.33039 1.47723 6.25851 1.45182 6.14764C1.43273 6.06436 1.43273 5.93303 1.45182 5.84975C1.47723 5.73889 1.52262 5.66701 1.61341 5.52325C2.36369 4.33526 4.59693 1.33203 8.00027 1.33203C11.4036 1.33203 13.6369 4.33526 14.3871 5.52325C14.4779 5.66701 14.5233 5.73889 14.5487 5.84975C14.5678 5.93303 14.5678 6.06436 14.5487 6.14764C14.5233 6.25851 14.4779 6.33039 14.3871 6.47415C13.6369 7.66214 11.4036 10.6654 8.00027 10.6654C4.59693 10.6654 2.36369 7.66214 1.61342 6.47415Z"
        stroke="#101010"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00027 7.9987C9.10484 7.9987 10.0003 7.10327 10.0003 5.9987C10.0003 4.89413 9.10484 3.9987 8.00027 3.9987C6.8957 3.9987 6.00027 4.89413 6.00027 5.9987C6.00027 7.10327 6.8957 7.9987 8.00027 7.9987Z"
        stroke="#101010"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OnlineSVG = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill="#41C667" />
    </svg>
  );
};

export const VideoStatsSVG = () => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.98951C1 3.01835 1 2.53277 1.20249 2.2651C1.37889 2.03191 1.64852 1.88761 1.9404 1.87018C2.27544 1.85017 2.67946 2.11953 3.48752 2.65823L14.0031 9.6686C14.6708 10.1137 15.0046 10.3363 15.1209 10.6168C15.2227 10.8621 15.2227 11.1377 15.1209 11.383C15.0046 11.6635 14.6708 11.886 14.0031 12.3312L3.48752 19.3415C2.67946 19.8802 2.27544 20.1496 1.9404 20.1296C1.64852 20.1122 1.37889 19.9679 1.20249 19.7347C1 19.467 1 18.9814 1 18.0103V3.98951Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChannelStatsSVG = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1189 17C17.4623 15.4151 19 12.7779 19 9.78496C19 4.9333 14.9704 1 10 1C5.02958 1 1 4.9333 1 9.78496C1 12.7779 2.53771 15.4151 4.88113 17M6.35967 13C5.51875 12.15 5 11.0086 5 9.75054C5 7.12711 7.23881 5 10 5C12.7612 5 15 7.12711 15 9.75054C15 11.0095 14.4813 12.15 13.6403 13M10 21C8.89543 21 8 20.1046 8 19V17C8 15.8954 8.89543 15 10 15C11.1046 15 12 15.8954 12 17V19C12 20.1046 11.1046 21 10 21ZM11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersStatsSVG = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StoriesStatsSVG = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 16V4C7 3.06812 7 2.60218 6.84776 2.23463C6.64477 1.74458 6.25542 1.35523 5.76537 1.15224C5.39782 1 4.93188 1 4 1C3.06812 1 2.60218 1 2.23463 1.15224C1.74458 1.35523 1.35523 1.74458 1.15224 2.23463C1 2.60218 1 3.06812 1 4V16C1 16.9319 1 17.3978 1.15224 17.7654C1.35523 18.2554 1.74458 18.6448 2.23463 18.8478C2.60218 19 3.06812 19 4 19C4.93188 19 5.39782 19 5.76537 18.8478C6.25542 18.6448 6.64477 18.2554 6.84776 17.7654C7 17.3978 7 16.9319 7 16Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14V6C17 5.06812 17 4.60218 16.8478 4.23463C16.6448 3.74458 16.2554 3.35523 15.7654 3.15224C15.3978 3 14.9319 3 14 3C13.0681 3 12.6022 3 12.2346 3.15224C11.7446 3.35523 11.3552 3.74458 11.1522 4.23463C11 4.60218 11 5.06812 11 6V14C11 14.9319 11 15.3978 11.1522 15.7654C11.3552 16.2554 11.7446 16.6448 12.2346 16.8478C12.6022 17 13.0681 17 14 17C14.9319 17 15.3978 17 15.7654 16.8478C16.2554 16.6448 16.6448 16.2554 16.8478 15.7654C17 15.3978 17 14.9319 17 14Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OnlineStatsSVG = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="21.5" cy="2.5" r="2.5" fill="#41C667" />
    </svg>
  );
};

export const MuteSVG = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 6.99993L15 12.9999M15 6.99993L21 12.9999M8.63432 2.36561L5.46863 5.5313C5.29568 5.70425 5.2092 5.79073 5.10828 5.85257C5.01881 5.9074 4.92127 5.9478 4.81923 5.9723C4.70414 5.99993 4.58185 5.99993 4.33726 5.99993H2.6C2.03995 5.99993 1.75992 5.99993 1.54601 6.10892C1.35785 6.20479 1.20487 6.35777 1.10899 6.54594C1 6.75985 1 7.03987 1 7.59993V12.3999C1 12.96 1 13.24 1.10899 13.4539C1.20487 13.6421 1.35785 13.7951 1.54601 13.8909C1.75992 13.9999 2.03995 13.9999 2.6 13.9999H4.33726C4.58185 13.9999 4.70414 13.9999 4.81923 14.0276C4.92127 14.0521 5.01881 14.0925 5.10828 14.1473C5.2092 14.2091 5.29568 14.2956 5.46863 14.4686L8.63431 17.6342C9.06269 18.0626 9.27688 18.2768 9.46077 18.2913C9.62033 18.3038 9.77626 18.2392 9.8802 18.1175C10 17.9773 10 17.6744 10 17.0686V2.9313C10 2.32548 10 2.02257 9.8802 1.88231C9.77626 1.76061 9.62033 1.69602 9.46077 1.70858C9.27688 1.72305 9.06269 1.93724 8.63432 2.36561Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UnMuteSVG = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7479 1.99993C20.1652 3.97016 21 6.38756 21 8.99993C21 11.6123 20.1652 14.0297 18.7479 15.9999M14.7453 4.99993C15.5362 6.13376 16 7.51268 16 8.99993C16 10.4872 15.5362 11.8661 14.7453 12.9999M8.63432 2.36561L5.46863 5.5313C5.29568 5.70425 5.2092 5.79073 5.10828 5.85257C5.01881 5.9074 4.92127 5.9478 4.81923 5.9723C4.70414 5.99993 4.58185 5.99993 4.33726 5.99993H2.6C2.03995 5.99993 1.75992 5.99993 1.54601 6.10892C1.35785 6.20479 1.20487 6.35777 1.10899 6.54594C1 6.75985 1 7.03987 1 7.59993V10.3999C1 10.96 1 11.24 1.10899 11.4539C1.20487 11.6421 1.35785 11.7951 1.54601 11.8909C1.75992 11.9999 2.03995 11.9999 2.6 11.9999H4.33726C4.58185 11.9999 4.70414 11.9999 4.81923 12.0276C4.92127 12.0521 5.01881 12.0925 5.10828 12.1473C5.2092 12.2091 5.29568 12.2956 5.46863 12.4686L8.63431 15.6342C9.06269 16.0626 9.27688 16.2768 9.46077 16.2913C9.62033 16.3038 9.77626 16.2392 9.8802 16.1175C10 15.9773 10 15.6744 10 15.0686V2.9313C10 2.32548 10 2.02257 9.8802 1.88231C9.77626 1.76061 9.62033 1.69602 9.46077 1.70858C9.27688 1.72305 9.06269 1.93724 8.63432 2.36561Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoOfViewsWhiteSVG = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.61342 6.47415C1.52262 6.33039 1.47723 6.25851 1.45182 6.14764C1.43273 6.06436 1.43273 5.93303 1.45182 5.84975C1.47723 5.73889 1.52262 5.66701 1.61341 5.52325C2.36369 4.33526 4.59693 1.33203 8.00027 1.33203C11.4036 1.33203 13.6369 4.33526 14.3871 5.52325C14.4779 5.66701 14.5233 5.73889 14.5487 5.84975C14.5678 5.93303 14.5678 6.06436 14.5487 6.14764C14.5233 6.25851 14.4779 6.33039 14.3871 6.47415C13.6369 7.66214 11.4036 10.6654 8.00027 10.6654C4.59693 10.6654 2.36369 7.66214 1.61342 6.47415Z"
        stroke="#f0f0f0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00027 7.9987C9.10484 7.9987 10.0003 7.10327 10.0003 5.9987C10.0003 4.89413 9.10484 3.9987 8.00027 3.9987C6.8957 3.9987 6.00027 4.89413 6.00027 5.9987C6.00027 7.10327 6.8957 7.9987 8.00027 7.9987Z"
        stroke="#f0f0f0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteStorySVG = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33854 3.9987V3.46536C9.33854 2.71863 9.33854 2.34526 9.19322 2.06004C9.06539 1.80916 8.86141 1.60519 8.61053 1.47736C8.32531 1.33203 7.95195 1.33203 7.20521 1.33203H6.13854C5.3918 1.33203 5.01844 1.33203 4.73322 1.47736C4.48234 1.60519 4.27836 1.80916 4.15053 2.06004C4.00521 2.34526 4.00521 2.71863 4.00521 3.46536V3.9987M5.33854 7.66536V10.9987M8.00521 7.66536V10.9987M0.671875 3.9987H12.6719M11.3385 3.9987V11.4654C11.3385 12.5855 11.3385 13.1455 11.1206 13.5733C10.9288 13.9497 10.6228 14.2556 10.2465 14.4474C9.8187 14.6654 9.25865 14.6654 8.13854 14.6654H5.20521C4.0851 14.6654 3.52505 14.6654 3.09723 14.4474C2.7209 14.2556 2.41494 13.9497 2.2232 13.5733C2.00521 13.1455 2.00521 12.5855 2.00521 11.4654V3.9987"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RedirectSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DeleteStoryWhiteSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33854 3.9987V3.46536C9.33854 2.71863 9.33854 2.34526 9.19322 2.06004C9.06539 1.80916 8.86141 1.60519 8.61053 1.47736C8.32531 1.33203 7.95195 1.33203 7.20521 1.33203H6.13854C5.3918 1.33203 5.01844 1.33203 4.73322 1.47736C4.48234 1.60519 4.27836 1.80916 4.15053 2.06004C4.00521 2.34526 4.00521 2.71863 4.00521 3.46536V3.9987M5.33854 7.66536V10.9987M8.00521 7.66536V10.9987M0.671875 3.9987H12.6719M11.3385 3.9987V11.4654C11.3385 12.5855 11.3385 13.1455 11.1206 13.5733C10.9288 13.9497 10.6228 14.2556 10.2465 14.4474C9.8187 14.6654 9.25865 14.6654 8.13854 14.6654H5.20521C4.0851 14.6654 3.52505 14.6654 3.09723 14.4474C2.7209 14.2556 2.41494 13.9497 2.2232 13.5733C2.00521 13.1455 2.00521 12.5855 2.00521 11.4654V3.9987"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopyLinkSVG = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.14098 11.2442L6.19817 12.1871C4.89642 13.4888 2.78587 13.4888 1.48412 12.1871C0.182375 10.8853 0.182376 8.77476 1.48412 7.47301L2.42693 6.5302M10.9122 7.47301L11.855 6.5302C13.1568 5.22845 13.1568 3.1179 11.855 1.81615C10.5533 0.514407 8.44273 0.514407 7.14098 1.81615L6.19817 2.75896M4.33624 9.33492L9.00291 4.66826"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddLinkSVG = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.14098 11.2442L6.19817 12.1871C4.89642 13.4888 2.78587 13.4888 1.48412 12.1871C0.182375 10.8853 0.182376 8.77476 1.48412 7.47301L2.42693 6.5302M10.9122 7.47301L11.855 6.5302C13.1568 5.22845 13.1568 3.1179 11.855 1.81615C10.5533 0.514407 8.44273 0.514407 7.14098 1.81615L6.19817 2.75896M4.33624 9.33492L9.00291 4.66826"
        stroke="#808080"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhatsappSVG = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#25D366"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6592 31.1271H20.6543C18.6639 31.1264 16.7082 30.627 14.9711 29.6796L8.66667 31.3333L10.3539 25.1707C9.31312 23.3671 8.76549 21.3212 8.76638 19.2252C8.76899 12.6681 14.104 7.33334 20.6591 7.33334C23.8405 7.33472 26.8265 8.57323 29.0718 10.8212C31.3172 13.069 32.553 16.057 32.5518 19.2346C32.5492 25.7902 27.2162 31.1244 20.6592 31.1271ZM15.2632 27.5266L15.6242 27.7408C17.1418 28.6414 18.8815 29.1179 20.6552 29.1186H20.6592C26.1074 29.1186 30.5416 24.6843 30.5438 19.2339C30.5448 16.5927 29.5176 14.1092 27.6514 12.2408C25.7852 10.3724 23.3033 9.34295 20.6631 9.34204C15.2108 9.34204 10.7765 13.7759 10.7743 19.2259C10.7736 21.0937 11.2961 22.9126 12.2856 24.4864L12.5206 24.8604L11.5221 28.508L15.2632 27.5266ZM26.2437 21.7951C26.4509 21.8952 26.5909 21.9629 26.6507 22.0626C26.7249 22.1865 26.7249 22.7815 26.4774 23.4757C26.2297 24.1698 25.0426 24.8033 24.4716 24.8886C23.9597 24.9652 23.3118 24.9971 22.6 24.7709C22.1684 24.6339 21.6149 24.4511 20.9059 24.1449C18.1201 22.942 16.2375 20.242 15.8817 19.7317C15.8568 19.696 15.8394 19.6709 15.8296 19.658L15.8272 19.6548C15.67 19.4449 14.6163 18.039 14.6163 16.584C14.6163 15.2152 15.2886 14.4978 15.5981 14.1675C15.6193 14.1449 15.6388 14.1241 15.6563 14.105C15.9287 13.8075 16.2506 13.7331 16.4487 13.7331C16.6468 13.7331 16.8451 13.735 17.0182 13.7437C17.0396 13.7447 17.0618 13.7446 17.0848 13.7445C17.258 13.7435 17.4738 13.7422 17.6868 14.2538C17.7688 14.4506 17.8887 14.7425 18.0151 15.0504C18.2708 15.6729 18.5533 16.3607 18.603 16.4602C18.6773 16.6089 18.7268 16.7824 18.6278 16.9808C18.6129 17.0106 18.5992 17.0386 18.586 17.0655C18.5116 17.2173 18.4569 17.3291 18.3306 17.4765C18.281 17.5345 18.2297 17.597 18.1784 17.6594C18.0761 17.7839 17.9739 17.9084 17.8849 17.9971C17.7361 18.1453 17.5813 18.3061 17.7546 18.6036C17.9279 18.9011 18.5243 19.8741 19.4077 20.6621C20.3573 21.5091 21.1826 21.8671 21.601 22.0485C21.6827 22.084 21.7489 22.1127 21.7974 22.137C22.0944 22.2858 22.2678 22.2609 22.4411 22.0626C22.6145 21.8643 23.184 21.1949 23.382 20.8974C23.5801 20.6001 23.7783 20.6496 24.0506 20.7487C24.3231 20.848 25.784 21.5668 26.0812 21.7155C26.1392 21.7446 26.1934 21.7708 26.2437 21.7951Z"
        fill="#FDFDFD"
      />
    </svg>
  );
};

export const LinkedInSVG = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z"
        fill="#0077B5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4323 12.3522C14.4323 13.6598 13.448 14.7061 11.8677 14.7061H11.8387C10.3171 14.7061 9.33334 13.6598 9.33334 12.3522C9.33334 11.017 10.347 10 11.8975 10C13.448 10 14.4029 11.017 14.4323 12.3522ZM14.1338 16.5649V30.183H9.60135V16.5649H14.1338ZM30.4793 30.183L30.4795 22.3748C30.4795 18.1919 28.2435 16.2451 25.261 16.2451C22.8545 16.2451 21.7771 17.5669 21.1756 18.4941V16.5652H16.6426C16.7023 17.8431 16.6426 30.1833 16.6426 30.1833H21.1756V22.5779C21.1756 22.1709 21.205 21.7649 21.3248 21.4735C21.6524 20.6604 22.3982 19.8185 23.6504 19.8185C25.2912 19.8185 25.9471 21.0673 25.9471 22.8973V30.183H30.4793Z"
        fill="white"
      />
    </svg>
  );
};

export const TwitterSVG = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z"
        fill="#55ACEE"
      />
      <path
        d="M19.401 16.2563L19.443 16.9483L18.7435 16.8636C16.1974 16.5387 13.973 15.4371 12.0844 13.5869L11.1611 12.6689L10.9233 13.3468C10.4197 14.858 10.7414 16.454 11.7907 17.5274C12.3503 18.1205 12.2243 18.2053 11.2591 17.8522C10.9233 17.7392 10.6295 17.6545 10.6016 17.6968C10.5036 17.7957 10.8394 19.0809 11.1052 19.5894C11.4689 20.2955 12.2104 20.9876 13.0218 21.3972L13.7072 21.722L12.8958 21.7361C12.1124 21.7361 12.0844 21.7502 12.1684 22.0468C12.4482 22.9649 13.5534 23.9394 14.7844 24.3631L15.6518 24.6597L14.8964 25.1116C13.7772 25.7613 12.4622 26.1285 11.1471 26.1567C10.5176 26.1709 10 26.2273 10 26.2697C10 26.411 11.7067 27.2019 12.7 27.5126C15.6798 28.4306 19.2191 28.0351 21.8772 26.4674C23.7658 25.3517 25.6543 23.1343 26.5357 20.9876C27.0113 19.8436 27.487 17.7533 27.487 16.7506C27.487 16.1009 27.529 16.0162 28.3124 15.2394C28.774 14.7874 29.2077 14.2931 29.2916 14.1519C29.4315 13.8835 29.4175 13.8835 28.7041 14.1236C27.515 14.5473 27.3471 14.4908 27.9346 13.8553C28.3683 13.4033 28.8859 12.5842 28.8859 12.3441C28.8859 12.3017 28.6761 12.3723 28.4383 12.4994C28.1865 12.6407 27.6269 12.8525 27.2072 12.9796L26.4518 13.2197L25.7663 12.7537C25.3885 12.4994 24.8569 12.217 24.5771 12.1322C23.8637 11.9345 22.7725 11.9627 22.129 12.1887C20.3803 12.8243 19.2751 14.4626 19.401 16.2563Z"
        fill="white"
      />
    </svg>
  );
};

export const StoryKebabSVG = () => {
  return (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.69141C1 9.24369 1.44771 9.69141 2 9.69141C2.55228 9.69141 3 9.24369 3 8.69141C3 8.13912 2.55228 7.69141 2 7.69141C1.44771 7.69141 1 8.13912 1 8.69141Z"
        fill="black"
      />
      <path
        d="M0.999999 15.6914C0.999999 16.2437 1.44771 16.6914 2 16.6914C2.55228 16.6914 3 16.2437 3 15.6914C3 15.1391 2.55228 14.6914 2 14.6914C1.44771 14.6914 0.999999 15.1391 0.999999 15.6914Z"
        fill="black"
      />
      <path
        d="M1 1.69141C1 2.24369 1.44772 2.69141 2 2.69141C2.55228 2.69141 3 2.24369 3 1.69141C3 1.13912 2.55228 0.691406 2 0.691406C1.44772 0.691406 1 1.13912 1 1.69141Z"
        fill="black"
      />
      <path
        d="M1 8.69141C1 9.24369 1.44771 9.69141 2 9.69141C2.55228 9.69141 3 9.24369 3 8.69141C3 8.13912 2.55228 7.69141 2 7.69141C1.44771 7.69141 1 8.13912 1 8.69141Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.999999 15.6914C0.999999 16.2437 1.44771 16.6914 2 16.6914C2.55228 16.6914 3 16.2437 3 15.6914C3 15.1391 2.55228 14.6914 2 14.6914C1.44771 14.6914 0.999999 15.1391 0.999999 15.6914Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1.69141C1 2.24369 1.44772 2.69141 2 2.69141C2.55228 2.69141 3 2.24369 3 1.69141C3 1.13912 2.55228 0.691406 2 0.691406C1.44772 0.691406 1 1.13912 1 1.69141Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddContactSVG = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.588 8.06801V5.88401H2.5V5.11601H4.588V2.93201H5.452V5.11601H7.54V5.88401H5.452V8.06801H4.588Z"
        fill="#307AE9"
      />
      <rect
        x="0.25"
        y="0.682007"
        width="9.54"
        height="9.636"
        rx="4.77"
        stroke="#307AE9"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const UpArrowSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20V4M12 4L6 10M12 4L18 10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProgressSVG = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 13H1M11 6.33333L7 10.3333M7 10.3333L3 6.33333M7 10.3333V1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HourglassSVG = () => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 17.5H11M2.6 1H13.4C13.9601 1 14.2401 1 14.454 1.10899C14.6422 1.20487 14.7951 1.35785 14.891 1.54601C15 1.75992 15 2.03995 15 2.6V4.67452C15 5.1637 15 5.40829 14.9447 5.63846C14.8957 5.84254 14.8149 6.03763 14.7053 6.21657C14.5816 6.4184 14.4086 6.59135 14.0627 6.93726L11.1314 9.86863C10.7354 10.2646 10.5373 10.4627 10.4632 10.691C10.3979 10.8918 10.3979 11.1082 10.4632 11.309C10.5373 11.5373 10.7354 11.7354 11.1314 12.1314L14.0627 15.0627C14.4086 15.4086 14.5816 15.5816 14.7053 15.7834C14.8149 15.9624 14.8957 16.1575 14.9447 16.3615C15 16.5917 15 16.8363 15 17.3255V19.4C15 19.9601 15 20.2401 14.891 20.454C14.7951 20.6422 14.6422 20.7951 14.454 20.891C14.2401 21 13.9601 21 13.4 21H2.6C2.03995 21 1.75992 21 1.54601 20.891C1.35785 20.7951 1.20487 20.6422 1.10899 20.454C1 20.2401 1 19.9601 1 19.4V17.3255C1 16.8363 1 16.5917 1.05526 16.3615C1.10425 16.1575 1.18506 15.9624 1.29472 15.7834C1.4184 15.5816 1.59135 15.4086 1.93726 15.0627L4.86863 12.1314C5.26465 11.7354 5.46265 11.5373 5.53684 11.309C5.6021 11.1082 5.6021 10.8918 5.53684 10.691C5.46266 10.4627 5.26464 10.2646 4.86863 9.86863L1.93726 6.93726C1.59136 6.59136 1.4184 6.4184 1.29472 6.21657C1.18506 6.03763 1.10425 5.84254 1.05526 5.63846C1 5.40829 1 5.1637 1 4.67452V2.6C1 2.03995 1 1.75992 1.10899 1.54601C1.20487 1.35785 1.35785 1.20487 1.54601 1.10899C1.75992 1 2.03995 1 2.6 1Z"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreenTickSVG = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6693 1.5L5.5026 10.6667L1.33594 6.5"
        stroke="#41C667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RedCrossSVG = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1.5L1 11.5M1 1.5L11 11.5"
        stroke="#ED431D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIconSVG = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 13.9999H14.75M1.25 13.9999H2.50591C2.87279 13.9999 3.05624 13.9999 3.22887 13.9585C3.38192 13.9217 3.52824 13.8611 3.66245 13.7789C3.81382 13.6861 3.94354 13.5564 4.20296 13.297L13.625 3.87493C14.2463 3.25361 14.2463 2.24625 13.625 1.62493C13.0037 1.00361 11.9963 1.00361 11.375 1.62493L1.95295 11.047C1.69352 11.3064 1.5638 11.4361 1.47104 11.5875C1.3888 11.7217 1.32819 11.868 1.29145 12.0211C1.25 12.1937 1.25 12.3772 1.25 12.744V13.9999Z"
        stroke="#5A5A5A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArchiveChannelSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM10.1 17.5H13.9C14.4601 17.5 14.7401 17.5 14.954 17.391C15.1422 17.2951 15.2951 17.1422 15.391 16.954C15.5 16.7401 15.5 16.4601 15.5 15.9V15.1C15.5 14.5399 15.5 14.2599 15.391 14.046C15.2951 13.8578 15.1422 13.7049 14.954 13.609C14.7401 13.5 14.4601 13.5 13.9 13.5H10.1C9.53995 13.5 9.25992 13.5 9.04601 13.609C8.85785 13.7049 8.70487 13.8578 8.60899 14.046C8.5 14.2599 8.5 14.5399 8.5 15.1V15.9C8.5 16.4601 8.5 16.7401 8.60899 16.954C8.70487 17.1422 8.85785 17.2951 9.04601 17.391C9.25992 17.5 9.53995 17.5 10.1 17.5ZM13.75 13.5V11.75C13.75 10.7835 12.9665 10 12 10C11.0335 10 10.25 10.7835 10.25 11.75V13.5H13.75Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ActiveChannelSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9 14L11 16L15.5 11.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DropDownSVG = () => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.5L6 6.5L11 1.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownArrowSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V20M12 20L18 14M12 20L6 14"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreenDownArrowSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V20M12 20L18 14M12 20L6 14"
        stroke="#50FB81"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreyDownArrowSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V20M12 20L18 14M12 20L6 14"
        stroke="#cccccc"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChatBotSVG = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60" cy="60" r="60" fill="#1B3426" />
      <path
        d="M56.2491 52.5056C56.6896 51.2534 57.559 50.1975 58.7034 49.5249C59.8478 48.8524 61.1933 48.6065 62.5016 48.8309C63.8099 49.0553 64.9966 49.7355 65.8514 50.751C66.7063 51.7665 67.1741 53.0518 67.1722 54.3792C67.1722 58.1264 61.5514 60 61.5514 60M61.6238 67.5H61.6488M61.2491 80C72.9851 80 82.4991 70.486 82.4991 58.75C82.4991 47.0139 72.9851 37.5 61.2491 37.5C49.513 37.5 39.9991 47.0139 39.9991 58.75C39.9991 61.125 40.3887 63.409 41.1075 65.5415C41.378 66.344 41.5132 66.7453 41.5376 67.0536C41.5617 67.358 41.5435 67.5714 41.4682 67.8674C41.3919 68.167 41.2236 68.4787 40.8868 69.102L36.7977 76.6709C36.2144 77.7505 35.9227 78.2903 35.988 78.7069C36.0449 79.0698 36.2584 79.3893 36.572 79.5806C36.932 79.8002 37.5423 79.7371 38.7629 79.6109L51.5655 78.2875C51.9532 78.2475 52.147 78.2274 52.3237 78.2342C52.4975 78.2408 52.6202 78.2572 52.7896 78.2962C52.9619 78.3359 53.1786 78.4194 53.6119 78.5863C55.9821 79.4994 58.5571 80 61.2491 80Z"
        stroke="#50FB81"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseChatBotSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12H19"
        stroke="#50FB81"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchBarSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
        stroke="#5C5C5C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChatBotHeaderSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 52 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2491 17.5056C23.6896 16.2534 24.559 15.1975 25.7034 14.5249C26.8478 13.8524 28.1933 13.6065 29.5016 13.8309C30.8099 14.0553 31.9966 14.7355 32.8514 15.751C33.7063 16.7665 34.1741 18.0518 34.1722 19.3792C34.1722 23.1264 28.5514 25 28.5514 25M28.6238 32.5H28.6488M28.2491 45C39.9851 45 49.4991 35.486 49.4991 23.75C49.4991 12.0139 39.9851 2.5 28.2491 2.5C16.513 2.5 6.99906 12.0139 6.99906 23.75C6.99906 26.125 7.38868 28.409 8.10749 30.5415C8.37799 31.344 8.51324 31.7453 8.53763 32.0536C8.56172 32.358 8.54351 32.5714 8.4682 32.8674C8.39193 33.167 8.22355 33.4787 7.88679 34.102L3.79765 41.6709C3.21437 42.7505 2.92274 43.2903 2.98801 43.7069C3.04486 44.0698 3.25843 44.3893 3.572 44.5806C3.93201 44.8002 4.54231 44.7371 5.76292 44.6109L18.5655 43.2875C18.9532 43.2475 19.147 43.2274 19.3237 43.2342C19.4975 43.2408 19.6202 43.2572 19.7896 43.2962C19.9619 43.3359 20.1786 43.4194 20.6119 43.5863C22.9821 44.4994 25.5571 45 28.2491 45Z"
        stroke="#50FB81"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SelectedSVG = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11.9375"
        cy="11"
        r="10"
        fill="#242424"
        stroke="#242424"
        strokeWidth="2"
      />
      <path
        d="M7.26953 11.666L9.9362 14.3327L16.6029 7.66602"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DefaultUserBigSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.86017 32.3973C9.87404 30.0086 12.2412 28.3333 14.9997 28.3333H24.9997C27.7581 28.3333 30.1253 30.0087 31.1392 32.3973M26.6663 15.8333C26.6663 19.5152 23.6816 22.5 19.9997 22.5C16.3178 22.5 13.333 19.5152 13.333 15.8333C13.333 12.1514 16.3178 9.16665 19.9997 9.16665C23.6816 9.16665 26.6663 12.1514 26.6663 15.8333ZM36.6663 20C36.6663 29.2047 29.2044 36.6666 19.9997 36.6666C10.7949 36.6666 3.33301 29.2047 3.33301 20C3.33301 10.7952 10.7949 3.33331 19.9997 3.33331C29.2044 3.33331 36.6663 10.7952 36.6663 20Z"
        stroke="#50FB81"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadAiSVG = () => {
  return (
    <svg
      width="40"
      height="30"
      viewBox="0 0 40 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5001 29.5H30.5C35.7467 29.5 40 25.2467 40 20C40 15.2115 36.4571 11.2504 31.8497 10.5951C30.937 4.87297 25.9792 0.5 20 0.5C13.3726 0.5 8 5.87258 8 12.5L8.00001 12.5145C3.53831 12.7733 0 16.4734 0 21C0 25.6944 3.80558 29.5 8.5 29.5H18.5001V17.6213L15.9143 20.2071C15.7191 20.4024 15.4025 20.4024 15.2072 20.2071L13.793 18.7929C13.5977 18.5976 13.5977 18.281 13.793 18.0858L18.9395 12.9393C19.5252 12.3536 20.475 12.3536 21.0608 12.9393L26.2072 18.0858C26.4025 18.281 26.4025 18.5976 26.2072 18.7929L24.793 20.2071C24.5977 20.4024 24.2812 20.4024 24.0859 20.2071L21.5001 17.6213V29.5Z"
        fill="#161823"
        fillOpacity="0.34"
      />
    </svg>
  );
};

export const CSVDownloadSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M14 11H8M10 15H8M16 7H8M15 19L18 22M18 22L21 19M18 22V16"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function UploadImageSVG() {
  return (
    <svg
      width="86"
      height="110"
      viewBox="0 0 86 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2176_81055)">
        <path
          d="M0 10C0 4.47715 4.47715 0 10 0H86V110H10C4.47715 110 0 105.523 0 100V10Z"
          fill="#FAFAFA"
        />
        <path
          d="M39 59L43 55M43 55L47 59M43 55V64M51 59.7428C52.2215 58.734 53 57.2079 53 55.5C53 52.4624 50.5376 50 47.5 50C47.2815 50 47.0771 49.886 46.9661 49.6977C45.6621 47.4848 43.2544 46 40.5 46C36.3579 46 33 49.3579 33 53.5C33 55.5661 33.8354 57.4371 35.1869 58.7935"
          stroke="#CCCCCC"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2176_81055">
          <rect width="86" height="110" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
